export enum TipoConteudoAgendado {
  PECA_PROCESSUAL = 'peca_processual',
  BLOCO_QUESTOES = 'bloco_questoes',
}
